export default __webpack_public_path__ + "static/media/s-squiggle-136.318c01a7.svg";